import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadMaisEguByIdFailed, loadMaisEguByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadMaisEguById(action) {
  try {
    const url = `${BACKEND_URL}/resources/mais-egu-types/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadMaisEguByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadMaisEguByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadMaisEguByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
